export default __webpack_public_path__ + "./fonts/calendar.c6a31c00.svg";